export enum StoreToken {
  metricFinder = 'metricFinder',
  user = 'user',
  season = 'season',
  socket = 'socket',
  appState = 'appState'
}
